import React from 'react';

import { __t, applyTranslations } from 'utils/language';

applyTranslations(require('./system-message.i18n.json'));

import SystemMessage from './SystemMessage';

type Props = {
  text: string,
  isBrand: boolean
};

class SystemChatMessageOfferExpired extends SystemMessage<Props> {
  render() {
    const {
      text,
      isBrand
    } = this.props;

    const disclaimer = __t('system_message.revoked_creator_description');

    return (
      <React.Fragment>
        {this.renderIcon('broken-heart-inside-circle-custom-fg')}
        <div className="messages-system-message__container">
          <div className="messages-system-message__bubble">
            <div className="messages-system-message__heading">
              {text}
            </div>
            { !isBrand && this.renderDisclaimer(disclaimer) }
          </div>
        </div>
        {this.renderFooter()}
      </React.Fragment>
    );
  }
}

export default SystemChatMessageOfferExpired;
